import * as deepEqualExternal from "deep-equal";

/**
 * Traverses an object using a dot-separated path and returns the nested value.
 * Example: getByPath({a: {b: {c: 1}}}, 'a.b.c') => 1
 */
export function getNestedValue(obj, path) {
   if (!obj || !path) return undefined;
   return path
      .split(".")
      .reduce((acc, key) => (acc ? acc[key] : undefined), obj);
}

/**
 * Updates a nested value in an object using a dot-separated path.
 * Example: setByPath({a: {b: {c: 1}}}, 'a.b.c', 2) => {a: {b: {c: 2}}}
 */
export function setNestedValue(obj, path, value) {
   if (!obj || !path) return obj;
   const keys = path.split(".");
   const lastKey = keys.pop();
   const target = keys.reduce((acc, key) => (acc ? acc[key] : undefined), obj);
   if (target) target[lastKey] = value;
   return obj;
}

export function deepEqual(val1, val2) {
   return deepEqualExternal(val1, val2, { strict: true });
}